import React, {useState} from "react";
import {useModel} from "../helpers/model/use_model.js";
import {ModelCountriesMain} from "../models/country.js";
import {Select} from "antd";
import 'antd/lib/select/style/index.css'
import 'antd/lib/style/themes/default.less'
import {useStateContext} from "../helpers/state-context/use_state_context.js";
import './search.scss'
import ArrowRightIcon from '../assets/Arrow_searchCountry.svg'
import {CircleIcon} from "./ui/circle-icon.js";
import {ModelConsumer} from "../helpers/model/model-consumer.js";
import {categoriesMapping, getCategoryById} from "./categories/categories_mapping.js";
import parse from "html-react-parser";
import BellIcon from '../assets/bell.svg';
import {Analytics} from '../helpers/analytics';


function Search(props){
    const [hover, setHover] = useState('');
    const [visible, setVisible] = useState(false);
    const [state, dispatch] = useStateContext();
    const isMobile = ['xs'].includes(state.renderSize);
    const countries = useModel(ModelCountriesMain, (model)=>model.getData());

    const onSelect = (countryName) => {
        const country = countries.data.raw.find(countryItem=>countryItem.country_name === countryName)
        Analytics.trackEvent({
            action: 'select country',
            category: 'dropdown',
            label: country.country_name
        });
        dispatch({type: 'page', value: 'country'});
        dispatch({type: 'country', value: country.country_code});
    }

    if(countries.status === ModelCountriesMain.Status.SUCCESS){
        return <div id={`search`}
                className={visible ? 'dropdown-open' : 'dropdown-closed'}
                style={{
                    zIndex:"9",
                    position:"fixed",
                    left:"0",
                    bottom:"2%",
                    right:"0",
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center"
                }}>
           <div className={'dropdown-container'}>
               <Select onChange={(value)=>onSelect(value)}
                       showSearch={true}
                       getPopupContainer={() => (document.getElementById('search'))}
                       style={{width: 200}}
                       value={'Select a country'}
                       placeholder={''}
                       dropdownClassName={'animation'}
                       onDropdownVisibleChange={(open)=>{
                           setVisible(open);
                           if(!open){
                               setHover('')
                           }
                       }}>
                    {countries.data.raw
                        .sort((a, b)=>a.country_name.localeCompare(b.country_name))
                        .map((country)=>{
                            return <Select.Option key={country.country_name} value={country.country_name}>
                                <div onMouseEnter={()=>setHover(country.country_code)}
                                        onMouseLeave={()=>setHover('')}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            padding: '5px 12px'
                                        }}
                                >
                                    {parse(country.country_name)}
                                    {(hover === country.country_code) ?
                                            <img alt={'arrow_right'} style={{width: 20}} src={ArrowRightIcon}/> :
                                                null
                                    }
                                </div>
                            </Select.Option>
                        })
                    }
               </Select>
               {(!isMobile) ?
                   <ModelConsumer model={ModelCountriesMain}>
                       {(resultSet) =>{
                           let bell;
                           const countriesEU = [
                               "BE", "BG", "CZ", "DK", "DE", "EE", "IE", "EL", "ES", "FR", "HR", "IT", "CY",
                               "LV", "LT", "LU", "HU", "MT", "NL", "AT", "PL", "PT", "RO", "SI", "SK", "FI",
                               "SE", "EU"
                           ];
                           const activeCountriesEU = resultSet.data.raw.filter((c)=>(countriesEU.includes(c.country_code) && c.is_active))
                           if(activeCountriesEU.length > 0){
                               bell = <CircleIcon id={'share-button'}
                                                  src={BellIcon}
                                                  imageStyle={{
                                                      width: 15,
                                                      height: 15
                                                  }}
                                                  style={{
                                                      backgroundColor: "#fff",
                                                      width: 10,
                                                      height: 10,
                                                      position: 'absolute',
                                                      cursor: 'default',
                                                      top: -20,
                                                      right: -10,
                                                      fontSize: 20}}
                                                  alt={'bell_icon'}/>
                           }
                           const countryEU = resultSet.data.raw.find((c)=>c.country_code === 'EU');
                           const categories = [];
                           for(const [key, category] of categoriesMapping.entries()){
                               if(countryEU && countryEU[`category_${category.id}`] &&
                                   countryEU[`category_${category.id}`] === true){
                                   // If category 8 is true while there are other categories selected aswell skip category 8.
                                   if(key === 7 && countryEU.category_8 === true && categories.length > 0){
                                       break;
                                   }
                                   categories.push(category.id);
                               }
                           }
                           let color = '';
                           if ((!state.countryHover &&
                               state.categories.some((category) => categories.includes(category)))) {
                               color = getCategoryById(categories[0]).color;
                               if(state.categories.length === 1 || state.selectedCategory || state.countryHover) {
                                   color = getCategoryById(state.categories[0]).color
                               }
                           }
                           const styleEUIcon = {
                               margin: '5px 15px 5px',
                               backgroundColor: color,
                               width: '100%',
                               borderRadius: 50,
                               fontSize: 12
                           };
                           if(countryEU){
                               return <CircleIcon id={'eu-button'} style={styleEUIcon}
                                                  bell={bell}
                                                  onClick={()=> {
                                                      if(!state.categories.includes(8)) {
                                                          Analytics.trackEvent({
                                                              action: 'select country',
                                                              category: 'dropdown',
                                                              label: 'EU wide'
                                                          });
                                                          dispatch({type: 'page', value: 'country'});
                                                          dispatch({type: 'country', value: "EU"});
                                                      }
                                                  }}
                                                  onMouseEnter={(country)=>{
                                                      if(!state.categories.includes(8)){
                                                          dispatch({type: 'countryHover', value: countryEU.country_code})
                                                          dispatch({type: 'categories', value: categories})
                                                      }
                                                  }}
                                                  onMouseLeave={()=>{
                                                      if(!state.categories.includes(8)){
                                                          dispatch({type: 'countryHover', value: null});
                                                          if (state.selectedCategory) {
                                                              dispatch({type: 'categories', value: [state.selectedCategory]});
                                                          } else {
                                                              dispatch({type: 'setDefaultCategories'})
                                                          }
                                                      }

                                                  }}
                                                  text={'EU wide'}/>
                           }

                       }}
                   </ModelConsumer> :
                    null}
           </div>
        </div>
    }
    return null;
}

export {Search}